import _buffer from "buffer";
const {
  Buffer: _Buffer
} = _buffer;
export default {
  serialize(value) {
    return _Buffer.from([value ? 1 : 0]);
  },
  deserialize(buffer) {
    return buffer[0] === 1;
  }
};
//# sourceMappingURL=boolean.mjs.map